import { JsonOrderItem } from "./JsonOrderItem"

export interface JsonBasketStats{
    skuQuantity:number // total count of unique products
    totalQuantity:number
    retailSum:number
    retailSumDollar:number
    wholesaleSum:number
    wholesaleSumDollar:number
    discountAmountByCouponCode:{[code:string]:number}
    discountAmountByCouponCodeInDollar?:{[code:string]:number}
    giftCertificatesQuantity:number
    jsonOrderItems?:JsonOrderItem[]
    couponCodesToRemove?:string[]
    productIdsToRemove?:number[]
}

export function getTotalAmountToPayByJsonBasketStats(p:{stats:JsonBasketStats, useWholesaleSum:boolean}){
    let result = p.useWholesaleSum?p.stats.wholesaleSum:p.stats.retailSum
    for(let key of Object.keys(p.stats.discountAmountByCouponCode)){
        result -= p.stats.discountAmountByCouponCode[key]
    }
    if(result<0){
        result = 0
    }
    return result
}

export function getTotalAmountToPayByJsonBasketStatsInDollar(p:{stats:JsonBasketStats, useWholesaleSum:boolean}){
    let result = p.useWholesaleSum ? p.stats.wholesaleSumDollar : p.stats.retailSumDollar
    if(!result) return 0
    if(p.stats.discountAmountByCouponCodeInDollar){
        for(let key of Object.keys(p.stats.discountAmountByCouponCodeInDollar)){
            result -= p.stats.discountAmountByCouponCodeInDollar?.[key]
        }
    }
    return result > 0 ? result : 0
}

